<script>
import { currencies } from '../data/coins.js'
import { formatCurrencyName } from '../utils/currency.js'
import { selectedCurrencyCode } from '../stores.js'
import config from '../config.js'
import Icon from '../components/Icon.svelte'
import searchIcon from '../assets/icon/cil-search.svg'

export let color = 'white'
export let inline = false

const sortedCurrencies = Object.values(currencies).sort((a, b) => {
  return a.code < b.code
})

let filteredCurrencies = sortedCurrencies.slice(0, 5)

function filter (query) {
  if (query && query.length) {
    return sortedCurrencies.filter(currency => {
      return ([currency.name, currency.code, ...currency.countries, currency.coins[0].unit].join('|')).toLowerCase().includes(query.toLowerCase())
    }).slice(0, 5)
  } else return sortedCurrencies.slice(0, 5)
}

let searchQuery = null

$: {
  filteredCurrencies = filter(searchQuery)
}

function selectCurrency (currency) {
  if (currency && currency.code) {
    $selectedCurrencyCode = currency.code
    if (!inline) searchQuery = null
  }
}
</script>

<style type="text/scss">
  .search-bar {
    position: relative;

    .search-input {
      padding: .1em 0.5em;
      margin: 0.5em;
      width: 15rem;
      background: none;
      outline: none;
      border: none;
      border-bottom: solid 2px white;
      color: white;
    }

    .placeholder {
      position: absolute;
      top: .6em;
      left: 1em;
      opacity: 0.75;
      transition: opacity 100ms;
      pointer-events: none;

      &.hidden {
        opacity: 0;
      }
    }

    .search-results {
      position: relative;
      max-height: 100vh;
      transition: max-height 500ms;

      .result, .blank-line {
        background: none;
        margin: 0;
        padding: .5em;
        background: var(--light-bold-a);
        color: white;

        &:nth-child(odd) {
          background: var(--bold-a);
        }
      }

      .result {
        cursor: pointer;

        &:hover {
          background: var(--light-e);
        }
      }

      &.inline {
        .result, .blank-line {
          width: 15rem;
        }
      }

      .blank-line {
        opacity: none;
      }


    }

    .search-input:focus ~ .search-results {
      max-height: 100vh;
    }

    &.inline {
      .search-results {
        .result, .blank-line {
          width: 15rem;
        }
      }
    }

    &:not(.inline) {
      .search-input {
        width: 320px;
        max-width: 90vw;
        padding-left: 2em;
      }

      .placeholder {
        left: 2.5em;
      }

      .search-icon {
        position: absolute;
        top: 50%;
        left: 0.8em;
        transform: translateY(-50%);
      }

      .search-results {
        position: absolute;
        top: calc(100%);
        left: 0;
        right: 0;
        z-index: 80;
        max-height: 0;
        overflow: hidden;
      }
    }
  }
</style>

<div class="search-bar" class:inline>
  <span class="placeholder" class:hidden={searchQuery && searchQuery.length} style="color: {color};">Search for a currency...</span>
  <input
    class="search-input"
    type="text"
    bind:value={searchQuery}
    style="color: {color}; border-color: {color}"
  >
  {#if !inline }
    <span class="search-icon"><Icon icon={searchIcon} color={color} /></span>
  {/if}
  <div class="search-results">
    {#each filteredCurrencies as result }
      <p class="result" on:click={() => { selectCurrency(result) }}>
        { formatCurrencyName(result) }
      </p>
    {:else}
      <p class="result">no matches!</p>
    {/each}
    {#if inline }
      {#each Array(5 - (filteredCurrencies.length || 1)) as blankCount }
        <p class="blank-line">&nbsp;</p>
      {:else}
        <!-- nothing -->
      {/each}
    {/if}
  </div>
</div>
